<template lang="pug">
  DefaultLayout
    ProjectList2(archived)
</template>

<script>
import DefaultLayout from '@/layouts/Default.vue';
import ProjectList2 from '@/components/ProjectList2.vue';

export default {
  name: 'ProjectsArchivedPage',
  components: { DefaultLayout, ProjectList2 },
};
</script>
